import React, { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import apiRoutes from "../../../api/apiRoutes";
import { apiFetchJson } from "../../../utils/http";
import ClienteAutocomplete from "../../../components/autocomplete/ClienteAutocomplete";

// Formateo PY
function formatMontoView(value) {
  if (value == null || value === "") return "-";
  const onlyDigits = String(value).replace(/[^\d]/g, "");
  if (!onlyDigits) return "-";
  const num = Number(onlyDigits);
  if (!Number.isFinite(num)) return String(value);
  return num.toLocaleString("es-PY");
}

export default function CrearSolicitudLimite({
  onBack = () => {},
  onGuardar = async () => {},
  initialData = {},
}) {
  // ==== overlay ====
  const openOverlay = (detail) => {
    if (window.overlay?.open) window.overlay.open(detail || {});
    else window.dispatchEvent(new CustomEvent("overlay:open", { detail }));
  };

  // ==== Cliente seleccionado ====
  const [clienteId, setClienteId] = useState(initialData.clienteId ?? null);
  const [clienteNombre, setClienteNombre] = useState(initialData.clienteNombre ?? "");

//errores
  const [errorCampos, setErrorCampos] = useState(false);
  const [errorLimite, setErrorLimite] = useState("");
  // ==== Datos iniciales ====
  const [ultimoMontoAprobado, setUltimoMontoAprobado] = useState(initialData.ultimoMontoAprobado ?? "");
  const [totalLimiteTarjetas, setTotalLimiteTarjetas] = useState(initialData.totalLimiteTarjetas ?? "");
  const [fechaSolicitud, setFechaSolicitud] = useState(initialData.fechaSolicitud ?? "");
  const [estado, setEstado] = useState(initialData.estado ?? "SOLICITUD PENDIENTE");
  const [usuarioSolicitud, setUsuarioSolicitud] = useState(initialData.usuarioSolicitud ?? "");

  // ==== Editables ====
  const [textoMotivoSolicitud, settextoMotivoSolicitud] = useState("");
  const [valorMontoSolicitado, setValorMontoSolicitado] = useState("");

  const [saving, setSaving] = useState(false);

  // ==== NUEVO: estado para Límite Final ====
  const [limiteFinal, setLimiteFinal] = useState(0);

  // Recalcular límite final automáticamente
  useEffect(() => {
    const montoAprobadoNum = Number(String(ultimoMontoAprobado).replace(/[^\d-]/g, "")) || 0;
    const solicitadoNum = Number(String(valorMontoSolicitado).replace(/[^\d-]/g, "")) || 0;
    const totalTarjetasNum = Number(String(totalLimiteTarjetas).replace(/[^\d]/g, "")) || 0;

    const final = montoAprobadoNum + solicitadoNum;
    setLimiteFinal(final);

    if (final < totalTarjetasNum) {
      setErrorLimite("Límite de Crédito Final no puede ser menor a Total Límite de Tarjetas");
    } else {
      setErrorLimite("");
    }
  }, [ultimoMontoAprobado, valorMontoSolicitado, totalLimiteTarjetas]);
  // Validación
  const camposValidos =
    Boolean(clienteId) &&
    textoMotivoSolicitud.trim() !== "" &&
    valorMontoSolicitado.trim() !== "" &&
    !errorLimite;


  // ============================
  //     Monto solicitado
  // ============================

  const handleMontoSolicitadoChange = (e) => {
    const raw = e.target.value;

    // permitir solo números y un "-" al inicio
    let cleaned = raw.replace(/[^\d-]/g, "");

    // evitar múltiples "-"
    if (cleaned.indexOf("-") > 0) {
      cleaned = cleaned.replace(/-/g, "");
    }

    // permitir escribir solo "-"
    if (cleaned === "-") {
      setValorMontoSolicitado("-");
      return;
    }

    if (!cleaned) {
      setValorMontoSolicitado("");
      return;
    }

    const num = Number(cleaned);
    if (!Number.isFinite(num)) return;

    setValorMontoSolicitado(num.toLocaleString("es-PY"));
  };

  // ============================
  //           Submit
  // ============================

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (saving) return;

    if (!camposValidos) {
      setErrorCampos(true);
      return;
    }
    setErrorCampos(false);

    const payload = {
      clienteId,
      clienteNombre,
      textoMotivoSolicitud,
      valorMontoSolicitado: limiteFinal,
      ultimoMontoAprobado,
      totalLimiteTarjetas,
      fechaSolicitud,
      estado,
      usuarioSolicitud,
      limiteFinal, // opcionalmente enviar si backend lo necesita
    };

    setSaving(true);
    openOverlay({
      mode: "loading",
      title: "Creando solicitud…",
      message: "Por favor, espere sin cerrar ni recargar la página.",
    });

    try {
      await apiFetchJson(apiRoutes.limiteCredito.crear, {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=UTF-8" },
        body: JSON.stringify(payload),
      });

      openOverlay({
        mode: "success",
        title: "Solicitud creada",
        message: "La solicitud de límite de crédito fue creada correctamente.",
        onClose: async () => {
          try {
            await onGuardar(payload);
          } catch {}
          onBack();
        },
      });
    } catch (e2) {
      const msg =
        e2?.message ||
        (typeof e2?.body === "string" ? e2.body : null) ||
        "No se pudo crear la solicitud.";
      openOverlay({
        mode: "error",
        title: "Error al crear solicitud",
        message: msg,
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page">
      <div className="mb-4 flex items-center gap-3">
        <h2 className="page-title m-0">Creación Solicitud de Límite de Crédito</h2>
      </div>

      <div className="text-xs text-red-600 ml-1 mt-1">* Campos obligatorios. Si desea disminuir el Limite de Credito asigne valores negativos a Valor Monto Solicitado:</div>

      {errorCampos && (
        <div className="text-red-600 text-sm mb-2">
          Completá todos los campos obligatorios antes de guardar.
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="rounded-md border border-gray-200 bg-white px-6 py-5 space-y-4">

          {/* === Cliente === */}
          <div className="form-row items-center gap-2">
            <div className="form-label">
              Cliente<span className="text-red-600">*</span>:
            </div>

            <div className="flex-1">
              <ClienteAutocomplete
                value={clienteId ? { id: clienteId, nombre: clienteNombre } : null}
                onChange={async (cliente) => {
                  if (!cliente) {
                    setClienteId(null);
                    setClienteNombre("");
                    return;
                  }

                  setClienteId(cliente.id);
                  setClienteNombre(cliente.nombre ?? "");

                  // 🔥 cargar INIT (igual que antes)
                  try {
                    const url = apiRoutes.limiteCredito.initByCliente(cliente.id);
                    const res = await apiFetchJson(url, true);

                    setUltimoMontoAprobado(res.ultimoMontoAprobado ?? "");
                    setTotalLimiteTarjetas(res.totalLimiteTarjetas ?? "");
                    setFechaSolicitud(res.dataFechaSolicitud ?? "");
                    setEstado(res.estadoNombre ?? "SOLICITUD PENDIENTE");
                    setUsuarioSolicitud(res.codigoUsuarioSolicitud ?? "");
                  } catch {}
                }}
                disabled={saving}
              />
            </div>
          </div>

          {/* === Último Monto Aprobado === */}
          <div className="form-row items-center gap-2">
            <div className="form-label">Último Monto Aprobado:</div>
            <div className="flex-1">
              <div className="input-readonly">{formatMontoView(ultimoMontoAprobado)}</div>
            </div>
          </div>

          {/* === Total Límite de Tarjetas === */}
          <div className="form-row items-center gap-2">
            <div className="form-label">Total Límite de Tarjetas:</div>
            <div className="flex-1">
              <div className="input-readonly">{formatMontoView(totalLimiteTarjetas)}</div>
            </div>
          </div>

          {/* === Fecha Solicitud === */}
          <div className="form-row items-center gap-2">
            <div className="form-label">Fecha Solicitud:</div>
            <div className="flex-1">
              <div className="input-readonly">{fechaSolicitud}</div>
            </div>
          </div>

          {/* === Motivo Solicitud === */}
          <div className="form-row items-center gap-2">
            <div className="form-label">
              Motivo Solicitud:<span className="text-red-600">*</span>
            </div>
            <div className="flex-1">
              <input
                type="text"
                className="input w-full"
                value={textoMotivoSolicitud}
                onChange={(e) => settextoMotivoSolicitud(e.target.value)}
                disabled={saving}
              />
            </div>
          </div>

          {/* === Valor Monto Solicitado === */}
          <div className="form-row items-center gap-2">
            <div className="form-label">
              Valor Monto Solicitado:<span className="text-red-600">*</span>
            </div>
            <div className="flex-1">
              <input
                type="text"
                className={`input w-full ${errorLimite ? "border-red-500 bg-red-50" : ""}`}
                value={valorMontoSolicitado}
                onChange={handleMontoSolicitadoChange}
                disabled={saving}
              />
              {errorLimite && (
                <div className="text-red-600 text-xs mt-1">
                  {errorLimite}
                </div>
              )}
            </div>
          </div>

          {/* === Límite de Crédito Final (NUEVO) === */}
          <div className="form-row items-center gap-2">
            <div className="form-label">Límite de Crédito Final:</div>
            <div className="flex-1">
              <div className="input-readonly">
                {limiteFinal ? limiteFinal.toLocaleString("es-PY") : "-"}
              </div>
            </div>
          </div>

          {/* === Estado === */}
          <div className="form-row items-center gap-2">
            <div className="form-label">Estado:</div>
            <div className="flex-1">
              <div className="input-readonly">{estado}</div>
            </div>
          </div>

          {/* === Usuario Solicitud === */}
          <div className="form-row items-center gap-2">
            <div className="form-label">Usuario Solicitud:</div>
            <div className="flex-1">
              <div className="input-readonly">{usuarioSolicitud}</div>
            </div>
          </div>

          {/* === OBS === */}
          <div className="mt-4 rounded-md border border-gray-200 bg-gray-50 px-4 py-3 text-xs leading-relaxed text-gray-700">
            <p className="mb-2">
              <strong>OBS:</strong> Enviar los siguientes documentos a{" "}
              <a href="mailto:petrobrasflota@nextar.com.py" className="text-emerald-700 underline">
                petrobrasflota@nextar.com.py
              </a>{" "}
              para el análisis de la solicitud.
            </p>

            <ul className="list-disc pl-5 space-y-1">
              <li>Sociedad Anónima y Sociedad de Responsabilidad Limitada.</li>
              <li>Calificación Bancaria otorgada por la central de riesgos del B.C.P.</li>
              <li>Estados Financieros (últimos tres ejercicios fiscales).</li>
              <li>Balance General y Estado de Resultados.</li>
              <li>Flujo de Caja proyectado ("Cash Flow").</li>
              <li>Declaraciones de Impuesto a la Renta.</li>
              <li>Declaraciones de IVA, últimos seis meses.</li>
              <li>Escritura de Constitución y Acta de Poderes.</li>
              <li>CI de representantes y RUC de la empresa.</li>
            </ul>
          </div>
        </div>

        <div className="flex items-center justify-end gap-2 pt-2">
          <button type="button" className="btn-fil" onClick={onBack} disabled={saving}>
            Cancelar
          </button>

          <button
            type="submit"
            className="btn-fil disabled:opacity-60 disabled:cursor-not-allowed"
            disabled={saving || !camposValidos}
          >
            {saving ? "Guardando…" : "Guardar"}
          </button>
        </div>
      </form>
    </div>
  );
}
